import { useEffect, useState } from 'react';
import Utils from '@/utils/utils';
import { useUrlInfo } from '@/utils/hooks';
import LoadingPage from './components/LoadingPage';
import channelCenterApi from '@/api/channelcenter';
import  './Loading.scss';

function Loading({ loading }) {
  const isLandingPageType5 = Utils.params2json(`${window.location.search}`.slice(1), '&').landingPageType === '5';
  const isCustomBook = Utils.params2json(`${window.location.search}`.slice(1), '&').sceneId === '3948894';
  const [visible, setVisible] = useState(true);
  const [disabledData, setDisabledData] = useState({
    isDisable: 0,
    disableTips: ''
  });
  const { query: { sceneId }} = useUrlInfo();
  useEffect(() => {
    if(!isLandingPageType5 && !isCustomBook) {
      setLoading(true);
      // 防止不关闭loading的情况
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    if(loading === false) {
      if(!isLandingPageType5 && !isCustomBook) {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    }
  }, [loading]);

  useEffect(() => {
    getQrcode();
  }, []);

  //获取二维码信息
  function getQrcode() {
    channelCenterApi.get4Wechat({ sceneId: sceneId }).then((res) => {
      setDisabledData({
        isDisable: res.isDisable,
        disableTips: res.disableTips
      });
    });
  }

  const setLoading = (loading) => {
    const loadingPage = document.getElementById('Loading');
    if(loadingPage) {
      loadingPage.style.opacity = `${+loading}`;
      loadingPage.style.display = loading ? 'block' : 'none';
    }
  };

  const getPage = () => {
    // 禁用二维码直接不用loading
    if(disabledData.isDisable) {
      return null;
    }
    if(isLandingPageType5) {
      const showGuide = !(sessionStorage.getItem('landing_page_type') === '5');
      return visible && <LoadingPage isLoaded={!loading} finished={() => setVisible(false)} showGuide={showGuide} />;
    }
    return null;
  };
  return getPage();
}

export default Loading;
